var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicemanager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2522_17156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6 0H10.4C4.65624 0 0 4.65624 0 10.4V37.6C0 43.3438 4.65624 48 10.4 48H37.6C43.3438 48 48 43.3438 48 37.6V10.4C48 4.65624 43.3438 0 37.6 0Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5238 32.0633L28.0278 39.7513C26.8883 40.6742 25.4663 41.1778 23.9998 41.1778C22.5334 41.1778 21.1114 40.6742 19.9718 39.7513L10.4758 32.0633C10.105 31.7633 9.80586 31.3842 9.60038 30.9537C9.39491 30.5233 9.28827 30.0523 9.28827 29.5753C9.28827 29.0983 9.39491 28.6273 9.60038 28.1969C9.80586 27.7664 10.105 27.3873 10.4758 27.0873L19.9718 19.3953C21.1114 18.4724 22.5334 17.9688 23.9998 17.9688C25.4663 17.9688 26.8883 18.4724 28.0278 19.3953L37.5238 27.0873C37.8947 27.3873 38.1938 27.7664 38.3993 28.1969C38.6048 28.6273 38.7114 29.0983 38.7114 29.5753C38.7114 30.0523 38.6048 30.5233 38.3993 30.9537C38.1938 31.3842 37.8947 31.7633 37.5238 32.0633Z",
    fill: "url(#paint0_radial_2522_17156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4755 25.3725L19.9715 17.6805C21.1111 16.7575 22.533 16.2539 23.9995 16.2539C25.4659 16.2539 26.8879 16.7575 28.0275 17.6805L37.5235 25.3725C37.8943 25.6724 38.1935 26.0515 38.3989 26.482C38.6044 26.9125 38.7111 27.3835 38.7111 27.8605C38.7111 28.3375 38.6044 28.8084 38.3989 29.2389C38.1935 29.6694 37.8943 30.0485 37.5235 30.3485L28.0275 38.0365C26.8879 38.9594 25.4659 39.463 23.9995 39.463C22.533 39.463 21.1111 38.9594 19.9715 38.0365L10.4755 30.3485C10.1046 30.0485 9.80549 29.6694 9.60002 29.2389C9.39454 28.8084 9.2879 28.3375 9.2879 27.8605C9.2879 27.3835 9.39454 26.9125 9.60002 26.482C9.80549 26.0515 10.1046 25.6724 10.4755 25.3725Z",
    fill: "url(#paint1_radial_2522_17156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4758 15.4896L19.9718 7.79764C21.1114 6.8747 22.5334 6.37109 23.9998 6.37109C25.4663 6.37109 26.8883 6.8747 28.0278 7.79764L37.5238 15.4896C37.8947 15.7896 38.1938 16.1687 38.3993 16.5992C38.6048 17.0297 38.7114 17.5006 38.7114 17.9776C38.7114 18.4546 38.6048 18.9256 38.3993 19.3561C38.1938 19.7866 37.8947 20.1657 37.5238 20.4656L28.0278 28.1536C26.8883 29.0766 25.4663 29.5802 23.9998 29.5802C22.5334 29.5802 21.1114 29.0766 19.9718 28.1536L10.4758 20.4656C10.105 20.1657 9.80586 19.7866 9.60038 19.3561C9.39491 18.9256 9.28827 18.4546 9.28827 17.9776C9.28827 17.5006 9.39491 17.0297 9.60038 16.5992C9.80586 16.1687 10.105 15.7896 10.4758 15.4896Z",
    fill: "url(#paint2_radial_2522_17156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5235 22.1785L28.0275 29.8665C26.8879 30.7895 25.466 31.2931 23.9995 31.2931C22.5331 31.2931 21.1111 30.7895 19.9715 29.8665L10.4755 22.1785C10.1046 21.8786 9.80552 21.4995 9.60005 21.069C9.39457 20.6385 9.28793 20.1675 9.28793 19.6905C9.28793 19.2135 9.39457 18.7426 9.60005 18.3121C9.80552 17.8816 10.1046 17.5025 10.4755 17.2025L19.9715 9.51053C21.1111 8.58759 22.5331 8.08398 23.9995 8.08398C25.466 8.08398 26.8879 8.58759 28.0275 9.51053L37.5235 17.2025C37.8944 17.5025 38.1935 17.8816 38.399 18.3121C38.6044 18.7426 38.7111 19.2135 38.7111 19.6905C38.7111 20.1675 38.6044 20.6385 38.399 21.069C38.1935 21.4995 37.8944 21.8786 37.5235 22.1785Z",
    fill: "url(#paint3_radial_2522_17156)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2522_17156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.2198 29.7593) rotate(180) scale(29.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F7DF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#1F7DF1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2522_17156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4868 40.6747) rotate(-122.735) scale(23.3512 31.4581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DC2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4DC2A1",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4DC2A1",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4DC2A1",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#4DC2A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2522_17156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7798 17.7936) scale(29.824 29.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F05E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F05E56",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F05E56",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F05E56",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F05E56",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F05E56",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F05E56",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2522_17156",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2289 9.49089) rotate(57.2648) scale(23.3512 31.4581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA66CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#EA66CB",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EA66CB",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EA66CB",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#EA66CB",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EA66CB",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#EA66CB",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EA66CB",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EA66CB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2522_17156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicemanager);
export default __webpack_public_path__ + "static/media/devicemanager.e10d31f9b88975232daea2a8ab9fc946.svg";
export { ForwardRef as ReactComponent };